import { render } from "./LetsTalk.vue?vue&type=template&id=7f9ebb2a&scoped=true"
import script from "./LetsTalk.vue?vue&type=script&lang=js"
export * from "./LetsTalk.vue?vue&type=script&lang=js"

import "./LetsTalk.vue?vue&type=style&index=0&id=7f9ebb2a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f9ebb2a"]])

export default __exports__